import { hooks } from '@bilibili-maoer/web-utils'

import { NavigateOptions, URLSearchParamsInit, createSearchParams, useSearchParams } from 'react-router-dom'

import { useAppSelector } from '~/app/hooks'

export default function useAppSearchParam(defaultInit?: URLSearchParamsInit) {
  const navHide = useAppSelector((state) => state.Ui.navHide)

  const [searchParams, setRouterSearchParams] = useSearchParams(defaultInit)

  const setSearchParams = hooks.useEventCallback(
    (
      nextInit?: URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit),
      navigateOpts?: NavigateOptions
    ) => {
      if (!navHide) {
        return setRouterSearchParams(nextInit, navigateOpts)
      }
      if (typeof nextInit !== 'function') {
        const nextSearchParams = createSearchParams(nextInit)
        nextSearchParams.set('navHide', '1')
        return setRouterSearchParams(nextSearchParams, navigateOpts)
      }
      return setRouterSearchParams((prev) => {
        const nextSearchParams = createSearchParams(nextInit(prev))
        nextSearchParams.set('navHide', '1')
        return nextSearchParams
      }, navigateOpts)
    }
  )

  return [searchParams, setSearchParams] as const
}
